module.exports = __webpack_public_path__ + "static/img/FLG-qrcode.3fb4679.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/homepage/FLG-qrcode.jpg
// module id = mJeQ
// module chunks = 4